import { render } from "./v-green-button.vue?vue&type=template&id=620fce04&scoped=true"
import script from "./v-green-button.vue?vue&type=script&lang=js"
export * from "./v-green-button.vue?vue&type=script&lang=js"

import "./v-green-button.vue?vue&type=style&index=0&id=620fce04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620fce04"]])

export default __exports__